import styled from 'styled-components';
import Flex from '@deprecated-ui/common/Flex';

export const PreviewItem = styled.div`
  display: grid;
  grid-template-columns: 50% 50%;
  transition: all 0.3s ease;
  padding: 5px 10px;
  width: 100%;

  &.virtual {
    grid-template-columns: 35% 65%;
    grid-gap: 20px;

    p:last-child {
      color: #000;
    }
  }

  &:not(.virtual):not(:last-child) {
    border-bottom: 1px solid #f5f6f7;
  }

  &:not(.virtual) {
    &:hover {
      cursor: pointer;
      background: #f5f6f7;
    }
  }
`;

export const PreviewContainer = styled.div`
  width: 100%;
  border: 1px solid #ededed;
  border-radius: 5px;
  margin: 30px 0px 0px 10px;
`;

export const ConfirmationBox = styled.button`
  width: 100%;
  border: none;
  background: transparent;
  border-top: 1px solid #dadada;
  padding: 10px;
  margin: 30px 0px 0px 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

export const Checkbox = styled(Flex)`
  width: 20px;
  height: 20px;
  border: 1px solid #dadada;
  border-radius: 2px;
  margin-right: 10px;
`;
